var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,9.11c0,4.61-4.69,5.27-4.74,5.28h-.07a.5.5,0,0,1-.06-1c.16,0,3.87-.57,3.87-4.29a4.27,4.27,0,0,0-4.44-4.28.5.5,0,0,1-.47-.28A6.19,6.19,0,0,0,5.32,6.82a.48.48,0,0,1-.19.37.51.51,0,0,1-.41.09A3.09,3.09,0,0,0,1,10.3a3,3,0,0,0,3.05,3.08.5.5,0,0,1,.45.54.49.49,0,0,1-.54.45A4,4,0,0,1,0,10.3,4.08,4.08,0,0,1,4.38,6.23a7.18,7.18,0,0,1,13.47-2.4A5.27,5.27,0,0,1,23,9.11ZM16.5,14.2A5.5,5.5,0,1,1,11,8.7,5.51,5.51,0,0,1,16.5,14.2Zm-1,0A4.5,4.5,0,1,0,11,18.7,4.5,4.5,0,0,0,15.5,14.2Zm-2.85-1.36L10.5,15,9.35,13.84a.5.5,0,0,0-.7,0,.5.5,0,0,0,0,.71l1.5,1.5a.48.48,0,0,0,.7,0l2.5-2.5a.5.5,0,0,0,0-.71A.5.5,0,0,0,12.65,12.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploaded);
export default __webpack_public_path__ + "static/media/cloud-uploaded.f3fcc35d627f7bbbd1c76fc1df638237.svg";
export { ForwardRef as ReactComponent };